/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S2_Card3_TitleInputs */

const tr_cerez_s2_card3_title = /** @type {(inputs: Cerez_S2_Card3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`İşlev Çerezleri`)
};

const en_cerez_s2_card3_title = /** @type {(inputs: Cerez_S2_Card3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Functional cookies`)
};

const de_cerez_s2_card3_title = /** @type {(inputs: Cerez_S2_Card3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Funktions-Cookies`)
};

const ru_cerez_s2_card3_title = /** @type {(inputs: Cerez_S2_Card3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Функциональные файлы cookie`)
};

/**
* | output |
* | --- |
* | "Functional cookies" |
*
* @param {Cerez_S2_Card3_TitleInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s2_card3_title = /** @type {((inputs?: Cerez_S2_Card3_TitleInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S2_Card3_TitleInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s2_card3_title(inputs)
	if (locale === "de") return de_cerez_s2_card3_title(inputs)
	if (locale === "ru") return ru_cerez_s2_card3_title(inputs)
	return tr_cerez_s2_card3_title(inputs)
});